export const QuestionStatus = {
  AVAILABLE: 0,
  DISPATCHED: 1,
  ANSWERED_RIGHT: 2,
  ANSWERED_WRONG: 3,
  TIMED_OUT: 4,
};

export const GameStatus = {
  STOPPED: 0,
  STARTED: 1,
  FINISHED: 2,
};

export const CARDS_COORDS = [
  { top: -50, left: 60 },
  { top: -50, left: 236 },
  { top: -50, left: 424 },
  { top: 130, left: 125 },
  { top: 130, left: 310 },
  { top: 130, left: 500 },
  { top: 315, left: 200 },
  { top: 315, left: 400 },
];
